/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamSettingsSearchQueryVariables = {
    queryInput: string;
    orgRelayId: string;
    excludeCalendars?: Array<string | null> | null | undefined;
};
export type TeamSettingsSearchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"TeamSettingsSearch_viewer">;
    };
};
export type TeamSettingsSearchQuery = {
    readonly response: TeamSettingsSearchQueryResponse;
    readonly variables: TeamSettingsSearchQueryVariables;
};



/*
query TeamSettingsSearchQuery(
  $queryInput: String!
  $orgRelayId: ID!
  $excludeCalendars: [String]
) {
  viewer {
    ...TeamSettingsSearch_viewer_1L0Few
    id
  }
}

fragment TeamSettingsSearch_viewer_1L0Few on Viewer {
  orgPersonQueryResultErrorable(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on OrgPersonQueryResult {
      query
      persons {
        __typename
        calendarAliases
        redirectPersonId
        personId
        id
        primaryCalendarId
        isYou
        userId
        profile {
          givenName
          familyName
          externalImageUrl
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeCalendars"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryInput"
    } as any, v3 = {
        "kind": "Variable",
        "name": "excludeCalendars",
        "variableName": "excludeCalendars"
    } as any, v4 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "TeamSettingsSearchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "queryInput",
                                    "variableName": "queryInput"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "TeamSettingsSearch_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "TeamSettingsSearchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "query",
                                    "variableName": "queryInput"
                                }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "orgPersonQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "statusCode",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "message",
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "GraphEntityError",
                                    "abstractKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "query",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgPerson",
                                            "kind": "LinkedField",
                                            "name": "persons",
                                            "plural": true,
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "calendarAliases",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "redirectPersonId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "personId",
                                                    "storageKey": null
                                                },
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "primaryCalendarId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isYou",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "userId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UserProfile",
                                                    "kind": "LinkedField",
                                                    "name": "profile",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "givenName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "familyName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "externalImageUrl",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "OrgPersonQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v6 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "997804bc98d4f6297395ad4f8f2d6aef",
            "id": null,
            "metadata": {},
            "name": "TeamSettingsSearchQuery",
            "operationKind": "query",
            "text": "query TeamSettingsSearchQuery(\n  $queryInput: String!\n  $orgRelayId: ID!\n  $excludeCalendars: [String]\n) {\n  viewer {\n    ...TeamSettingsSearch_viewer_1L0Few\n    id\n  }\n}\n\nfragment TeamSettingsSearch_viewer_1L0Few on Viewer {\n  orgPersonQueryResultErrorable(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on OrgPersonQueryResult {\n      query\n      persons {\n        __typename\n        calendarAliases\n        redirectPersonId\n        personId\n        id\n        primaryCalendarId\n        isYou\n        userId\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '30ecf227dadaa89b9fe1d7c1921262dd';
export default node;
